import React from 'react'

const ErrorBoundary = () => {
  return (
    <div className='h-[90vh] flex flex-col items-center justify-center'>
        <h2 className='font-UncutSansVariable text-dark'> Something went wrong </h2>
        <p className='font-UncutSansVariable text-dark/50'>  An unexpected error occurred. Please try again later. </p>
        
     </div>
  )
}

 



// class ErrorBoundary extends React.Component {
//   constructor(props: {}) {
//     super(props);
//     this.state = { hasError: false, error: null };
//   }

//   static getDerivedStateFromError(error: any) {
//     // Update state so the next render shows the fallback UI
//     return { hasError: true, error };
//   }

//   componentDidCatch(error: any, errorInfo: any) {
//     // You can log the error to an error reporting service here
//     console.error("ErrorBoundary caught an error:", error, errorInfo);
//   }

//   render() {
//     // @ts-ignore
//     if (this.state.hasError) {
//       // @ts-ignore
//       const { error } = this.state;

//       // Check for specific error types or messages
//       if (error?.message?.includes('404')) {
//         console.log('====================================');
//         console.log(error);
//         console.log('====================================');
//         return (
//           <div className="h-[90vh] flex flex-col items-center justify-center">
//             <h2 className="font-UncutSansVariable text-dark">Page Not Found</h2>
//             <p className="font-UncutSansVariable text-dark/50">
//               The page you are looking for does not exist.
//             </p>
//           </div>
//         );
//       }

//       // Default fallback for other errors
//       return (
//         <div className="h-[90vh] flex flex-col items-center justify-center">
//           <h2 className="font-UncutSansVariable text-dark">Something went wrong</h2>
//           <p className="font-UncutSansVariable text-dark/50">
//             An unexpected error occurred. Please try again later.
//           </p>
//         </div>
//       );
//     }

//     // Render children if no error
//     // @ts-ignore
//     return this.props.children;
//   }
// }

export default ErrorBoundary;
